import api from '../config/axios-conf';

export const getShop = (id) =>
    api.get(`/shops/${id}`);

export const updateShop = (id, data) =>
    api.put(`/shops/${id}`, data);
